module.exports = __webpack_public_path__ + "img/no-projects.ceaa0954.svg";